import { UseCaseGet } from '@shared/helper';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { PaymentMethod } from '@data/domain/payment-method.entity';
import { PaymentRepository } from '@data/repositories/payment.repository';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodUsecase implements UseCaseGet<PaymentMethod[]> {
  private readonly paymentRepository = inject(PaymentRepository);

  execute(): Observable<PaymentMethod[]> {
    return this.paymentRepository.paymentMethod();
  }
}
